import { ia, isPrimitiveValue } from 'lib/helpers/utility';

import { checkIsNestedKey, renderValue } from 'components/shared/ExpandableToolbar/lib/helpers';

import { getNestedKeys, getNewNestedValue } from './getNewNestedValue';

const ONLY_NEW_VALUE_KEYS = ['upload', 'delete'];

export const formatChangedValues = ({ activities, timezone }) => {
  return activities
    .map((activity) => {
      const { action, previousValues, currentValues } = activity;

      const isCreateOrDeleteAction = ['create', 'delete'].includes(action);
      const showOnlyNewValue = activity.showOnlyNewValue ?? ONLY_NEW_VALUE_KEYS.includes(action);
      const previousKeys = getNestedKeys(previousValues);
      const currentKeys = getNestedKeys(currentValues);

      const finalKeys = [...new Set([...previousKeys, ...currentKeys])];

      if (isCreateOrDeleteAction || !ia(finalKeys)) {
        return {
          ...activity,
          prefix: activity.sourceEntity || activity.prefix || '',
          showOnlyNewValue,
          formattedChanges: []
        };
      }

      const formattedChanges = finalKeys
        .map((key) => {
          const nestedKeySource = mergeValidValues(previousValues, currentValues);
          const isNestedKey = checkIsNestedKey(key, nestedKeySource);

          const prevValueRaw = getNewNestedValue(key, previousValues);

          const currValueRaw = getNewNestedValue(key, currentValues);

          const prevValue = renderValue({ key, value: prevValueRaw, timezone });
          const currValue = renderValue({ key, value: currValueRaw, timezone });

          if (prevValue === currValue) return null;

          const valueLength = Math.max(
            (prevValue || '').toString().length,
            (currValue || '').toString().length
          );

          return {
            key,
            isNestedKey,
            prevValueRaw,
            currValueRaw,
            prevValue,
            currValue,
            valueLength // temporary used in sorting
          };
        })
        .filter(Boolean);

      if (!ia(formattedChanges)) {
        return;
      }

      return {
        ...activity,
        prefix: activity.sourceEntity || activity.prefix || '',
        showOnlyNewValue,
        formattedChanges: formattedChanges
          .sort((a, b) => a.valueLength - b.valueLength)
          .map(({ valueLength: _, ...rest }) => rest)
      };
    })
    .filter(Boolean);
};

const mergeValidValues = (obj1, obj2) => {
  const mergedValues = { ...(obj1 || {}) };

  Object.keys(obj2 || {}).forEach((key) => {
    if (!Object.prototype.hasOwnProperty.call(mergedValues, key)) {
      mergedValues[key] = obj2[key];
    } else if (isPrimitiveValue(obj2[key])) {
      mergedValues[key] = obj2[key];
    }
  });

  return mergedValues;
};
